import React from 'react'
import MuiLocalGasStationIcon from '@mui/icons-material/LocalGasStation'

function GasStationIcon(props: any) {
  return <MuiLocalGasStationIcon {...props} />
}

export { GasStationIcon }
